let saTCM = [
  {
    path: '/saTCM/index',
    name: '圣爱中医馆',
    component: () => import('@/pages/registration/saTCM/index.vue')
  },
  {
    path: '/saTCM/areaList',
    name: '圣爱中医馆-馆区列表',
    component: () => import('@/pages/registration/saTCM/areaList.vue')
  },
  {
    path: '/saTCM/deptList',
    name: '圣爱中医馆-按科室挂号',
    component: () => import('@/pages/registration/saTCM/deptList.vue')
  },
  {
    path: '/saTCM/doctorList',
    name: '圣爱中医馆-按名医挂号',
    component: () => import('@/pages/registration/saTCM/doctorList.vue')
  },
  {
    path: '/saTCM/doctorDetail',
    name: '圣爱中医馆-医生详情',
    component: () => import('@/pages/registration/saTCM/doctorDetail.vue')
  },
  {
    path: '/saTCM/doctorListDepList',
    name: '圣爱中医馆-特色服务',
    component: () => import('@/pages/registration/saTCM/doctorListDepList.vue')
  },
  {
    path: '/saTCM/doctorListByDept',
    name: '圣爱中医馆-按科室挂号',
    component: () => import('@/pages/registration/saTCM/doctorListByDept.vue')
  }
]

export default saTCM